/*
    <v-list-tile v-for='action in appointmentActions'
        @click.native = 'performProcess(paymentRequestId, "schedule.models.AppointmentProcess.requestPayment", me.id, appointment.id)'  >
        <v-list-tile-title>Send invoice</v-list-tile-title>
    </v-list-tile>
*/
import {mapGetters} from 'vuex'
export default {
  name: 'AppointmentsMixin',
  methods: {
    getAppointmentActionItemsByKeyList (li) {
      return this.appointmentActions.filter((item) => {
        if (li.indexOf(item.id) !== -1) {
          return item
        }
      })
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters('appointments', ['getRecentlyUpdated']),
    appointmentActions () {
      let appointmentActions = []
      if (this.appointment.client) {
        appointmentActions = [
          {
            icon: 'open_in_new',
            id: 'appointment_view',
            title: 'Open Appointment',
            ownerCan: true,
            onclick: () => {
              this.$emit('actionselected')
              this.$emit('close')
              this.$router.push('/appointments/' + this.appointment.id)
            }
          },
          {
            icon: 'person',
            id: 'show_client',
            title: 'Show client',
            ownerCan: true,
            disableIf: (appointment) => {
              if (appointment) {
                if (appointment.status === 'B') { return true }
                if (!appointment.computed_relationship_id) { return true }
                return false
              } else {
                return true
              }
            },
            extraActions: (appointment) => {
              if (appointment && appointment.computed_relationship_id) {
                let relationshipId = appointment.computed_relationship_id

                // if (!relationshipId) {
                //   let clientId = appointment.client
                //   if (this.appointment.client.id) {
                //     clientId = this.appointment.client.id
                //   }
                //   relationshipId = this.getRelationByClientId(clientId)
                // }
                if (relationshipId) {
                  return [
                    {
                      icon: 'edit',
                      text: 'Edit',
                      action: (appointment) => {
                        // let relationship = this.getRelationByClientId(appointment.client)
                        this.$emit('actionselected')
                        this.$emit('close')
                        if (appointment && appointment.computed_relationship_id) {
                          this.launchCustomerDetailsDialog(appointment.computed_relationship_id, true)
                        }
                      }
                    }
                  ]
                }
                return []
              }
            },
            onclick: () => {
              this.$emit('actionselected')
              this.$emit('close')
              let relationshipId = this.getObjectPath(this.appointment, 'computed_relationship_id')
              if (relationshipId) {
                this.gotoRelationship(relationshipId)
              }
              // let clientId = this.appointment.client
              // if (this.appointment.client.id) {
              //   clientId = this.appointment.client.id
              // }
              // let client = this.getRelationByClientId(clientId)
              // this.gotoClient(client)
              // this.$router.push('/clients/' + clientId)
            }
          },
          { type: 'divider', id: 'div-price-stuff' },
          {
            id: 'bulk_add_codes',
            icon: 'local_hospital',
            title: 'Manage codes',
            ownerCan: true,
            onclick: (appointment) => {
              if (!appointment) {
                appointment = this.appointment
              }
              this.$emit('actionselected')
              let options = {
                appointmentId: appointment.id,
                value: appointment,
                editable: true,
                withTitle: true,
                withTotal: true,
                withRefresh: true,
                withInvoiceable: true
              }
              this.launchDiagnosisCodes(options)
            }
          },
          {
            id: 'create_invoice',
            icon: 'receipt',
            title: 'Invoice',
            ownerCan: true,
            onclick: (appointment) => {
              if (!appointment) {
                appointment = this.appointment
              }
              this.$emit('actionselected')
              this.launchInvoiceDetailsDialog(this.appointment)
              // this.openGlobalDialog(true, 'InvoiceDetails', {appointment: this.appointment})
            }
          },
          {
            icon: 'credit_card',
            id: 'bulk_add_payment',
            title: 'Track payment',
            ownerCan: true,
            disableIf: (appointment) => {
              return appointment.status === 'P'
            },
            onclick: (appointment) => {
              this.$emit('actionselected')
              if (!appointment) {
                appointment = this.appointment
              }
              let options = {
                appointment,
                touch: Math.random()
              }
              this.launchAppointmentPaymentDialog(options)
            }
          },
          // {
          //   icon: 'event',
          //   id: 'clone_appointment',
          //   title: 'Clone',
          //   onclick: () => {
          //     this.$emit('actionselected')
          //     this.openGlobalDialog(true, 'QuickCreate', {appointment: this.appointment})
          //   }
          // },
          // {
          //   icon: 'code',
          //   title: 'Add diagnosis codes',
          //   onclick: () => {
          //     this.$emit('actionselected')
          //     this.openGlobalDialog(true, 'InvoiceCodes', {appointment: this.appointment})
          //   }
          // },
          // { type: 'divider' },
          // {
          //   id: 'quick_codes',
          //   icon: 'functions',
          //   title: 'QuickCodes',
          //   onclick: () => {
          //     this.$emit('actionselected')
          //     this.openGlobalDialog(true, 'CodePicker', {appointment: this.appointment})
          //   }
          // },
          { type: 'divider', id: 'div-extra-stuff' },
          {
            id: 'add_note',
            icon: 'note_add',
            title: 'Add a note',
            ownerCan: true,
            onclick: () => {
              this.$emit('actionselected')
              let options = {appointment: this.appointment}
              this.openGlobalDialog(true, 'Notes', options)
            }
          },
          {
            id: 'bulk_add_products',
            icon: 'shopping_basket',
            title: 'Product sales',
            ownerCan: true,
            onclick: (appointment) => {
              if (!appointment) {
                appointment = this.appointment
              }
              this.$emit('actionselected')
              let options = {
                appointmentId: appointment.id
              }
              this.launchAppointmentProduct(options)
            }
          },
          // {
          //   id: 'send_invoice',
          //   icon: 'post_add',
          //   title: 'Create invoice',
          //   ownerCan: true,
          //   onclick: () => {
          //     let client = this.appointment.client
          //     if (!client.id) {
          //       client = this.getClientById(client)
          //     }
          //     if (client.client) {
          //       client = client.client
          //     }
          //     let options = {
          //       appointments: [this.appointment],
          //       client: client
          //     }
          //     this.launchQuickInvoiceDialog(options)
          //     /* this.performProcess(
          //       'process-request-send-payment',
          //       'schedule.models.AppointmentProcess.requestPayment',
          //       this.$store.getters.me.id,
          //       this.appointment.id
          //     ) */
          //     this.$emit('actionselected')
          //   }
          // },
          {
            id: 'bulk_make_online',
            icon: 'headset_mic',
            title: 'Make online',
            disableIf: (appointment) => {
              return appointment.is_online
            },
            onclick: () => {
              this.$emit('actionselected')
              let options = {appointment: this.appointment}
              this.launchMakeAppointmentOnline(options)
            }
          },
          {
            icon: 'tag',
            id: 'add_tags',
            title: 'Add tags',
            ownerCan: true,
            onclick: (appointment) => {
              this.$emit('actionselected')
              if (!appointment) {
                appointment = this.appointment
              }
              let options = {
                appointmentIds: [appointment.id]
              }
              this.launchAppointmentTags(options)
            }
          },
          { type: 'divider', id: 'div-schedule-stuff' },
          {
            id: 'bulk_reschedule',
            icon: 'replay',
            title: 'Reschedule',
            ownerCan: true,
            onclick: () => {
              this.$emit('actionselected')
              this.openGlobalDialog(true, 'Reschedule', {appointment: this.appointment})
            }
          },
          {
            icon: 'file_copy',
            id: 'clone',
            title: 'Clone',
            ownerCan: true,
            onclick: (appointment) => {
              this.$emit('actionselected')
              if (!appointment) {
                appointment = this.appointment
              }
              let options = {
                appointment: appointment,
                touch: Math.random()
              }
              this.launchCloneAppointment(options)
            },
            disableIf: (appointment) => {
              if (appointment.is_online === true) { return true }
              return false
            }
          },
          // {
          //   icon: 'send',
          //   id: 'send_message',
          //   title: 'Send message',
          //   onclick: (appointment) => {
          //     this.$emit('actionselected')
          //     if (!appointment) {
          //       appointment = this.appointment
          //     }
          //     let client = appointment.client
          //     if (Number.isInteger(client)) {
          //       client = this.getClientById(client)
          //     }
          //     let options = {
          //       touch: Math.random(),
          //       context: appointment,
          //       templateContext: 'Appointment',
          //       sender: appointment.practitioner,
          //       clients: [client]
          //     }
          //     this.launchAppointmentSendMessage(options)
          //   }
          // },
          // {
          //   id: 'mark_as_paid',
          //   icon: 'check',
          //   title: 'Mark as paid',
          //   onclick: () => {
          //     this.performProcess(
          //       'process-mark-as-paid',
          //       'schedule.models.AppointmentProcess.updateStatus',
          //       this.$store.getters.me.id,
          //       this.appointment.id,
          //       { status: 'P' }
          //     )
          //   }
          // },
          {
            id: 'bulk_cancel',
            icon: 'close',
            title: 'Cancel',
            ownerCan: true,
            onclick: () => {
              this.$emit('actionselected')
              this.openGlobalDialog(true, 'Cancel', {appointment: this.appointment})
            }
          },
          {
            id: 'bulk_delete',
            icon: 'delete',
            ownerCan: true,
            title: 'Delete',
            onclick: () => {
              this.$emit('actionselected')
              this.openGlobalDialog(true, 'Delete', {appointment: this.appointment})
            }
          }
        ]
      } else {
        appointmentActions = [
          {
            icon: 'open_in_new',
            id: 'open_appointment',
            title: 'Open Appointment',
            onclick: () => {
              this.$emit('actionselected')
              this.$emit('close')
              this.$router.push('/appointments/' + this.appointment.id)
            }
          },
          {
            icon: 'account_circle',
            id: 'assign_client',
            title: 'Assign to client',
            onclick: () => {
              let options = {
                value: this.appointment
              }
              this.launchSetAppointmentClient(options)
            }
          },
          {
            id: 'cancel_appointment',
            icon: 'close',
            title: 'Cancel',
            onclick: () => {
              this.$emit('actionselected')
              this.openGlobalDialog(true, 'Cancel', {appointment: this.appointment})
            }
          },
          {
            id: 'delete_appointment',
            icon: 'delete',
            title: 'Delete',
            onclick: () => {
              this.$emit('actionselected')
              this.openGlobalDialog(true, 'Delete', {appointment: this.appointment})
            }
          }
        ]
      }
      return appointmentActions
    },
    appointmentBulkActions () {
      return [
        {
          title: 'Add ICD-10 codes'
        },
        {
          title: 'Add a payment'
        },
        {
          title: 'Create an invoice'
        },
        {
          title: 'Add Tags'
        },
        {
          title: 'Cancel'
        },
        {
          title: 'Delete'
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/appointments.js